module.exports = __webpack_public_path__ + "assets/img/eb3004d384b2e1c193b226f80df1f79b.png";